import { Body } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import { Checkbox } from "baseui/checkbox";
import { HeadingSmall } from "baseui/typography";
import React from "react";

const repositories = [
  {
    value: "gadget",
    label: "gadget",
    description: "Updates made to the Gadget platform",
  },
  {
    value: "js-clients",
    label: "js-clients",
    description: "Updates made to one of the Gadget JavaScript clients",
  },
  {
    value: "ggt",
    label: "ggt (Gadget CLI)",
    description: "Updates made to the Gadget CLI",
  },
];

export default function ({
  handleRepositoryToggle,
  selectedRepositories,
}: {
  handleRepositoryToggle: (repositoryValue: string) => void;
  selectedRepositories: string[];
}) {
  const [css, $theme] = useStyletron();

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: $theme.sizing.scale400,
        alignSelf: "stretch",
      })}
    >
      <HeadingSmall>Filter by repository</HeadingSmall>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: $theme.sizing.scale400,
          alignSelf: "stretch",
          "@media (max-width: 1485px)": {
            flexDirection: "row",
          },
        })}
      >
        {repositories.map((repository, key) => (
          <div
            key={key}
            className={css({
              display: "flex",
              alignItems: "flex-start",
              alignSelf: "stretch",
            })}
          >
            <Checkbox
              checked={selectedRepositories.includes(repository.value)}
              onChange={() => handleRepositoryToggle(repository.value)}
              overrides={{
                Checkmark: {
                  style: {
                    borderWidth: "1px",
                  },
                },
              }}
            />
            <div
              className={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "3px",
                flex: "1 0 0",
              })}
            >
              <Body
                $style={{
                  fontFeatureSettings: "'liga' off, 'clig' off",
                  fontFamily: "Helvetica",
                  fontSize: $theme.sizing.scale550,
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: $theme.sizing.scale700,
                }}
              >
                {repository.label}
              </Body>
              <Body
                $style={{
                  color: $theme.colors.primary500,
                  fontFeatureSettings: "'liga' off, 'clig' off",
                  fontFamily: "Helvetica",
                  fontSize: $theme.sizing.scale550,
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: $theme.sizing.scale600,
                  alignSelf: "stretch",
                  "@media (max-width: 1485px)": {
                    display: "none",
                  },
                }}
              >
                {repository.description}
              </Body>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
